import { InventoryApi } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useBoundary = (inventoryId?: string, boundaryId?: string | null) => {
  return useQuery([INVENTORIES_QUERY_KEYS.BOUNDARIES, inventoryId, boundaryId], async () => {
    if (!inventoryId || !boundaryId) {
      return
    }
    const boundary = await InventoryApi.getBoundary(inventoryId, boundaryId)

    return boundary.data
  })
}
